module.exports = __webpack_public_path__ + "static/media/notFound.eac24d50.png";